// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import { FaPlus } from "react-icons/fa6";
import { InputField } from "./InputField";
import PrimaryButton from "./PrimaryButton";
import SelectOption from "./SelectOption";
import { ActionBothProps } from "../types/common";

const AddOwnVoiceModal: React.FC<ActionBothProps> = ({showPrev, showNext}) => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium tracking-tight mt-3">Upload your own voice and give it<br />some characteristics.</p>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-5">File upload</p>
      <div className="mt-3 w-full py-6 rounded-2xl border border-dashed border-[#9392A2] cursor-pointer">
        <FaPlus className="text-xl text-center w-full mb-2" />
        <p className="text-center text-[#9392A2] text-xs font-medium leading-snug tracking-tight">Upload a voice files here.<br/>It could be up to 25 files.</p>
      </div>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-5 mb-2">Information</p>
      <InputField label="Name of the voice" className="mb-1" />
      <SelectOption label="Gender of the voice" options={["Male", "Female"]} className="mb-1" />
      <SelectOption label="Type of voice" options={["Deep", "Soft"]} />
      <div className="flex items-center gap-1 mt-3">
        <PrimaryButton onClick={() => showPrev && showPrev()} className="py-2 rounded-3xl w-full" black label="Back" />
        <PrimaryButton onClick={() => showNext && showNext()} className="py-2 rounded-3xl w-full" label="Add voice" />
      </div>
    </>
  );
};

export default AddOwnVoiceModal;